import { message } from 'ant-design-vue';
message.config({
    top: `40vh`,
    duration: 3,
    maxCount: 5,
    prefixCls: 'black',
});